/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";

/*------------------------------------*\
    FAQ CAROUSEL
\*------------------------------------*/
class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            cellAlign: "center",
            contain: true,
            pageDots: false,
            autoPlay: 5000,
            imagesLoaded: true,
            wrapAround: true,
            prevNextButtons: false
        });
    };
}

export default Carousel;